import { render, staticRenderFns } from "./GovCancelVoteConfirmation.vue?vue&type=template&id=2cb1b054&"
import script from "./GovCancelVoteConfirmation.vue?vue&type=script&lang=js&"
export * from "./GovCancelVoteConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports